import { CourseWithLecturesEntity } from '../../../../../api/types/students/programs/student-programs-with-courses';

// Helper function to calculate attendance data from lectures
export const calculateAttendanceData = (course: CourseWithLecturesEntity) => {
  const lecturesWithAttendance =
    course.lectures?.filter((lecture) => lecture.attendanceId !== null) ?? [];
  const attendedLectures = lecturesWithAttendance.filter(
    (lecture) =>
      lecture.attendanceType === 'attended' ||
      lecture.attendanceType === 'late',
  );

  const attendanceCount = attendedLectures.length;
  const totalLecturesWithAttendance = lecturesWithAttendance.length;

  // If no attendance was recorded for any lecture, consider it 100% attendance
  // (student attended everything they were required to attend)
  const attendancePercentage =
    totalLecturesWithAttendance > 0
      ? Math.round((attendanceCount / totalLecturesWithAttendance) * 100)
      : 100;

  return {
    attendanceCount,
    attendancePercentage,
  };
};
